import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { ContentProvider } from './lib/content-context'
import { UXProvider } from './ux/context'
import { GameProvider } from './game/context/GameContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <UXProvider>
        <ContentProvider>
          <GameProvider>
            <App />
          </GameProvider>
        </ContentProvider>
      </UXProvider>
    </BrowserRouter>
  </React.StrictMode>
)
